import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const MonitorsIncidentsPerZone = () => {

    const monitorReport = true;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="ZONE" disaggregation = "validity"/>
        </>
    
  )
}

export default MonitorsIncidentsPerZone